import { render, staticRenderFns } from "./NewUserModal.vue?vue&type=template&id=31d65eda&scoped=true&"
import script from "./NewUserModal.vue?vue&type=script&lang=js&"
export * from "./NewUserModal.vue?vue&type=script&lang=js&"
import style0 from "./NewUserModal.vue?vue&type=style&index=0&id=31d65eda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d65eda",
  null
  
)

export default component.exports